import { View } from '@react-pdf/renderer';
import { SmallHeading } from 'PDF/components/SmallHeading';
import { StepsRow } from 'PDF/components/StepsTable/StepsRow';
import { getArrayOfColors } from 'PDF/helpers/documentStyle';
import { formatStepNumber } from 'PDF/helpers/formatStepNumber';

import { IStepsListItem } from './types';

interface IStepsList {
  heading?: string;
  list: IStepsListItem[];
}

export const StepsList = ({ heading, list }: IStepsList) => {
  const filteredList = list.filter(({ trendName, trendCharacteristics }) => trendName || trendCharacteristics);
  const arrayOfColors = getArrayOfColors();

  return !filteredList.length ? null : (
    <View style={{ marginBottom: 10 }}>
      {filteredList.map(({ trendName, trendCharacteristics, color }, index) => (
        <View key={index} wrap={index !== 0}>
          {index === 0 && heading && <SmallHeading heading={heading} />}
          <StepsRow
            color={color || arrayOfColors[index]}
            number={formatStepNumber(index + 1)}
            heading={trendName}
            text={trendCharacteristics}
          />
        </View>
      ))}
    </View>
  );
};
